import { StyledMainSection } from "@/styles/global";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardImage = styled.div<{ $type?: "image" | "text" }>`
  width: 100%;
  aspect-ratio: ${({ $type }) => ($type === "image" ? "1 / 1" : "322 / 228;")};
  overflow: hidden;
  border-radius: 10px;
  background-color: ${({ theme, $type }) =>
    theme.colors[$type === "image" ? "transparent" : "creme"]};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  position: relative;

  h3 {
    text-align: center;
  }
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
`;

const S = {
  Section,
  Grid,
  Card,
  CardImage,
  Image,
};

export default S;
